import { Provider as StoreProvider } from 'react-redux';

import './App.css';
import { AuthProvider } from './providers/AuthProvider';
import LocaleProvider from './providers/LocaleProvider';
import { ThemeProvider } from './providers/Theme';
import { AppRoutes } from './routes/Routes';
import store from './store/store';
import './styles/_antd.scss';
import './styles/_variables.scss';

function App() {
  return (
    <StoreProvider store={store}>
      <AuthProvider>
        <ThemeProvider>
          <LocaleProvider>
            <AppRoutes />
          </LocaleProvider>
        </ThemeProvider>
      </AuthProvider>
    </StoreProvider>
  );
}

export default App;
